export const environment = {
  production: false,
  environment_id: "stage",
  googleTagManagerId: "GTM-WMXKCM6",
  hubspotAccountId: 9267294,
  analytics_url: "https://analytics-backend.intiaro.com/analytics/",
  logout_url: "#", // probably deprecated
  intiaro_embed_url: "https://db3d-backend.stage.intiaro.com",
  main_domain: "https://backend.intiaro.com",
  unity_embed_domain: "https://db3d-backend.stage.intiaro.com",
  login_domain: "#", // probably deprecated
  registration_domain: "#", // probably deprecated
  password_reset_domain: "#", // probably deprecated
  country_list_domain: "#", // probably deprecated
  state_list_domain: "#", // probably deprecated
  product_list_domain: "#", // probably deprecated
  product_details_domain: "#", // probably deprecated
  product_list_filters_domain: "#", // probably deprecated
  save_design_domain: "#", // probably deprecated
  unity_build_domain: "https://db3d-backend.stage.intiaro.com",
  intiaro_api_domain: "#", // probably deprecated
  model_service_api_domain: "https://model-service.stage.intiaro.com/",
  request_furniture_ad_url: "https://demo.db3d.com/3d-model-request",
  player360CustomerId: "DB3D",
  db3dBackendDomain: "https://db3d-backend.eks-stage.intiaro.com",
  productDesignDemoPageToken: "d5fcffa47d9877eb833be908841ac600c8b38a65",
  intiaroConfiguratorDomainTemplateKey: "prod",
  db3dFrontendDomain: "https://db3d.aws-stage.intiaro.com",
  // db3dBackendDomain: 'http://localhost:8000',
  publicApiIntiaro: "https://public-api.intiaro.com",
  publicServicesIntiaro: "https://services.intiaro.com",
};
